import { useState, useMemo } from "react";
import { Container, Row, Col, Card, Button, Form, Tab, InputGroup } from "react-bootstrap";
import { t } from "i18next";

const ReportPreferenceTabContent = ({ reportTypes, onChange, form, selectedReportTypes, isEdit = false, toggleReportType, toggleDefaultSending, toggleAppearInSendingList, errors }) => {
    const [search, setSearch] = useState("");

    // Filtered reports based on search term
    const filteredReports = useMemo(() => {

        
        if (!search) return reportTypes;
        return reportTypes?.filter((report) =>
            report.name.toLowerCase().includes(search.toLowerCase()) ||
            report.name.toString().includes(search)
        );
    }, [reportTypes, search]);

    return (
        <Tab.Pane eventKey="reports">
            <Card className="shadow-sm">
                <Card.Body>
                    <div className="mb-3 d-flex justify-content-between align-items-start">
                        <div>
                            <h5 className="mb-1">{t("assigned_reports")}</h5>
                            <small className="text-muted">{t("assigned_reports_description")}</small>
                        </div>
                    </div>


                    {/*filteredReports?.length > 0 && <Form.Group className="mb-3">
                        <InputGroup>
                            <InputGroup.Text id="search-addon" style={{ backgroundColor: "#fff", borderRight: 0 }}>
                                🔍
                            </InputGroup.Text>
                            <Form.Control
                                placeholder={t("search_reports")}
                                aria-label="Search reports"
                                aria-describedby="search-addon"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                style={{
                                    borderLeft: 0,
                                    borderRadius: "0.25rem",
                                    boxShadow: "none",
                                }}
                            />
                        </InputGroup>
                    </Form.Group> */}
                    <Form.Group className="mb-3">
                        <InputGroup>
                            <InputGroup.Text id="search-addon" style={{ backgroundColor: "#fff", borderRight: 0 }}>
                                🔍
                            </InputGroup.Text>
                            <Form.Control
                                placeholder={t("search_reports")}
                                aria-label="Search reports"
                                aria-describedby="search-addon"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                style={{
                                    borderLeft: 0,
                                    borderRadius: "0.25rem",
                                    boxShadow: "none",
                                }}
                            />
                        </InputGroup>
                    </Form.Group>
                    <Row>
                        {filteredReports?.length > 0 ? (
                            filteredReports.map((report, index) => (
                                <Col md={6} lg={4} key={index} className="mb-3">
                                    <Card className="h-100 border-0 shadow-sm">
                                        <Card.Body className="d-flex align-items-start justify-content-between">
                                            <div className="flex-grow-1">
                                                <div className="fw-semibold">{report?.name}</div>
                                                <small className="text-muted">{t("report_code")}: {report?.name}</small>
                                                {selectedReportTypes?.some(r => r.id === report.id) && (
                                                    <>
                                                        {(() => {
                                                            const selectedReport = selectedReportTypes?.find(r => r.id === report.id);

                                                            return (
                                                                <>
                                                                    <div className="mt-2 ms-1">
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label={t("default_report_recipient")}
                                                                            checked={selectedReport?.defaultSending}
                                                                            disabled={selectedReport?.appearInSendingList}
                                                                            onChange={() => toggleDefaultSending(report?.id)}
                                                                            className="text-body"
                                                                        />
                                                                    </div>

                                                                    <div className="mt-2 ms-1">
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label={t("appear_sending_list")}
                                                                            checked={selectedReport?.appearInSendingList}
                                                                            disabled={selectedReport?.defaultSending}
                                                                            onChange={() => toggleAppearInSendingList(report?.id)}
                                                                            className="text-body"
                                                                        />
                                                                    </div>
                                                                </>
                                                            );
                                                        })()}
                                                    </>
                                                )}
                                            </div>

                                            <Form.Check
                                                type="switch"
                                                checked={selectedReportTypes?.some(r => r?.id === report?.id)}
                                                onChange={() => toggleReportType(report?.id)}
                                            />
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))
                        ) : (
                            <Col>
                                <div className="text-muted text-center py-3">{t("no_reports_found")}</div>
                            </Col>
                        )}
                    </Row>
                </Card.Body>
            </Card>
        </Tab.Pane>
    );
};

export default ReportPreferenceTabContent;
